import { Button, SearchBar } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { FadeLoader } from 'react-spinners';
import { useCompany } from './company.hook';

export const CompanyList = () => {
  const {
    columns,
    formattedData,
    setSearch,
    isLoadingCompanyData,
    setCompanyListLimit,
    openCompanyModal,
    companyListPage,
    setCompanyListPage,
    companyListLimit,
  } = useCompany();

  return (
    <div className="h-screen">
      <div className="flex justify-between items-center bg-[#232323] py-4 px-7 rounded-[8px]">
        <SearchBar
          type="text"
          placeholder="Rechercher par nom d'entreprise"
          handleChange={(e) => setSearch(e.target.value || '')}
          className="!w-[400px]"
        />
        <Button
          title="Ajouter"
          className="w-[149px] h-[41px]"
          onClick={openCompanyModal}
        />
      </div>

      {isLoadingCompanyData ? (
        <div className="w-full h-[100vh] flex items-center justify-center">
          <FadeLoader color="#FEC200" />
        </div>
      ) : (
        <DataTable
          columns={columns}
          value={formattedData || []}
          loading={isLoadingCompanyData}
          withPaginator={true}
          currentPage={companyListPage}
          currentPageHandler={setCompanyListPage}
          listlimit={companyListLimit}
          limitHandler={setCompanyListLimit}
          countTotal={formattedData?.length}
        />
      )}
    </div>
  );
};
